// import React from 'react';
import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';

import { Menu, X } from 'lucide-react';
import polarisTextLogoPic from '@/assets/logos/polaris-text-logo.png'
// import whiteStarPic from '@/assets/images/white-star.png'
//
// import platformInvestmentPic from '@/assets/images/platform-icons/platform-investment.png'
// import customerTrustPic from '@/assets/images/platform-icons/customer-trust.png'
// import investmentExperiencePic from '@/assets/images/platform-icons/investment-experience.png'
// import rareTargetsPic from '@/assets/images/platform-icons/rare-targets.png'
//
// import spacexLogo from '@/assets/logos/spacex.png'
// import xaiLogo from '@/assets/logos/xai.png'
// import neuralinkLogo from '@/assets/logos/neuralink.png'
// import cohereLogo from '@/assets/logos/cohere.png'
// import openaiLogo from '@/assets/logos/openai.png'
// import groqLogo from '@/assets/logos/groq.png'
// import andurilLogo from '@/assets/logos/anduril.png'
// import stripeLogo from '@/assets/logos/stripe.png'
// import anthropicLogo from '@/assets/logos/anthropic.png'
// import perplexityLogo from '@/assets/logos/perplexity.png'
// import bytedanceLogo from '@/assets/logos/bytedance.png'
// import coreweaveLogo from '@/assets/logos/coreweave.png'
// import figureLogo from '@/assets/logos/figure.png'
//
// import qrcodePic from '@/assets/images/qrcode.png'
// import whiteTextPic from '@/assets/images/white-text.png'
// import starNightPic from '@/assets/images/star-night.png'
// import astronautPic from '@/assets/images/astronaut.png'

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const [base, setBase] = React.useState<string>('/polaris-v2');
  return (
    <div className="min-h-screen bg-[#171717] text-white">
      {/* Hero Section */}
      <header className="container sticky top-0 z-50 bg-[#171717] mx-auto px-4 pt-9 pb-10 sm:pb-18 md:pb-20 lg:pb-24">
        <nav className="flex flex-wrap justify-between items-center">
          <div className="flex items-center">
            <Link to="/">
              <img src={polarisTextLogoPic} alt="POLARIS INVEST" className="h-[30px] sm:h-[45px] md:h-[50px] lg:h-[50px] xl:h-[50px] w-auto mix-blend-hard-light opacity-90" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Navigation Links */}
          <div className={`w-full lg:w-auto lg:flex gap-8 items-center ${isMenuOpen ? 'block' : 'hidden'}`}>
            <ul className="flex flex-col lg:flex-row gap-4 lg:gap-8 mt-4 lg:mt-0">
              <li><Link to="/" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">首页</Link></li>
              <li><Link to="/news" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">新闻</Link></li>
              <li><Link to="/company" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">公司</Link></li>
              <li><Link to="/ai-strategy" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">AI策略</Link></li>
              <li><Link to="/market" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">市场</Link></li>
              <li><Link to="/more" onClick={() => setIsMenuOpen(!isMenuOpen)} className="hover:text-blue-400 transition">更多</Link></li>
            </ul>
            <button className="bg-white text-black px-6 py-2 rounded-full hover:bg-gray-200 transition mt-4 lg:mt-0">
              Contact Us
            </button>
          </div>
        </nav>

      </header>

      {/* 子路由内容将在这里渲染 */}
      <Outlet />

      {/* Footer */}
      <footer className="bg-gray-900 py-8">
        <div className="container mx-auto px-4 text-center text-gray-400">
          <p>© 2025 Polaris Invest. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
